var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSecurityNegado(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8999 59.1499C35.4332 61.1166 37.8332 62.4166 40.4999 62.4166C45.0999 62.4166 48.8332 58.6833 48.8332 54.0833C48.8332 52.1833 48.1999 50.4166 47.1332 49.0166",
    stroke: "#1E729F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90008 70.0835C7.86675 67.5502 7.16675 63.5168 7.16675 57.4168V50.7502C7.16675 37.4168 10.5001 34.0835 23.8334 34.0835H57.1667C58.3667 34.0835 59.4667 34.1168 60.5001 34.1835C71.0667 34.7835 73.8334 38.6168 73.8334 50.7502V57.4168C73.8334 70.7502 70.5001 74.0835 57.1667 74.0835H23.8334C22.6334 74.0835 21.5334 74.0502 20.5001 73.9835",
    stroke: "#1E729F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 34.0832V27.4165C20.5 16.3832 23.8333 7.4165 40.5 7.4165C54.3333 7.4165 58.9667 12.0165 60.1667 19.2832",
    stroke: "#1E729F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8334 7.4165L7.16675 74.0832",
    stroke: "#1E729F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurityNegado);
export default __webpack_public_path__ + "static/media/iconSecurityNegado.dec7ef06f38f6fd2ccd2aa82228bf362.svg";
export { ForwardRef as ReactComponent };